import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../../services/login.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../auth/auth.service';
import {OAuthService} from "angular-oauth2-oidc";
import {environment} from '../../../../environments/environment';
import {I18nProvider} from "../../../services/i18n.service";
import {I18nPipe} from "../../../services/i18n.pipe";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginTitle: string;

  constructor(private loginService: LoginService, private router: Router, private authService: AuthService,
              private oauthService: OAuthService, private i18nProvider: I18nPipe ) {
  }

  ngOnInit(): void {
    this.loginTitle = this.i18nProvider.transform('header-main-title', '');
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['dashboard']).then();
    }
  }

  loginUser() {
    if (environment.azure) {
      this.oauthService.configure(this.authService.authCodeFlowConfig());
      this.oauthService.loadDiscoveryDocumentAndLogin().then(() => {
        this.loginService.loginUser().subscribe(() => this.handleLogin());
      });
    } else {
      this.loginService.loginUserTest().subscribe(() => this.handleLogin());
    }
  }

  private handleLogin() {
    this.loginService.handleLogin();
    this.router.navigate(['/dashboard']).then();
  }
  getLoginTitle(): string {
    return 'LOGIN TO THE DIGITAL WARRANTY CONTRACT PLATFORM';
  }
}
